import './App.css';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Pages
import WorkPage from './pages/WorkPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

// Components
import PrivateRoute from './components/PrivateRoute';

// Store
import store from './store/index';
import { Provider } from 'react-redux';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <div className="App">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/app" element={
                <PrivateRoute>
                  <WorkPage />
                </PrivateRoute>
              } />
              {/* Redireciona qualquer rota desconhecida */}
              <Route path="*" element={<Navigate to="/app" replace />} />
            </Routes>
          </div>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;